<template>
    <v-container>
      <v-btn icon
      @click="goBack">
        <v-icon>
          mdi-home
        </v-icon>
      </v-btn>
      <v-row>
        <v-col cols="12" class="text-h1" style="display: flex; justify-content: center">
          404
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack () {
      this.$router.push({ name: 'homepage' })
    }
  }
}
</script>

<style scoped>

</style>
